import React from 'react'
import PropTypes from 'prop-types'

const EventRow = ({ title }) => {
  return (
    <div className="package-builder-page_variations-section_card_events_row">
      <p>{title}</p>
    </div>
  )
}
  
EventRow.propTypes = {
  title: PropTypes.string,
}

export default EventRow